module.exports = __webpack_public_path__ + "static/Site-7-dd2fbf7bd858c710a59d08c19009b92e.jpg";